import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { IonContent } from '@ionic/angular';
import { Navigator } from 'src/app/services/routing/navigator';
import { DepositMainLabels } from 'src/app/interfaces/deposit-main-labels';
import { DepositMainModel } from 'src/app/models/deposit-models';
import { CashierContentService } from 'src/app/services/cashier/cashier-content.service';
import { CashierService } from 'src/app/services/cashier/cashier.service';
import { ConfigService } from 'src/app/services/config/config.service';
import { SuccessMessageService } from 'src/app/services/message-provider/success-message.service';
import { CashierBase } from '../../cashier-base/cashier-base';

@Component({
  selector: 'app-deposit-cage',
  templateUrl: './deposit-cage.component.html',
  styleUrls: ['./deposit-cage.component.scss'],
})
export class DepositCageComponent extends CashierBase implements OnInit {
  @ViewChild(IonContent, { static: false }) content: IonContent;
  @Input() public navigateBackPage: any;
  @Input() public pageCode: string;
 
  
  public error = null;
  public bonusCode: string;
  public labels: DepositMainLabels;
  public vendorLogoUrl: string = '';

  constructor(
    public cashierService: CashierService,
    public cashierContentService: CashierContentService,
    public navigator: Navigator,
    public successMessageService: SuccessMessageService,
    public configService: ConfigService
  ){
    super();
    this.successMessageService.clearMessage();
    this.labels = new DepositMainModel();
  }

  ngOnInit(){
    this.cashierContentService.bonusOfferValue.subscribe(res => this.bonusCode = res);
  }

  ngAfterViewInit(){
    let fileName = this.configService.getState() == 'Pennsylvania' ? 'casinocage-pa': 'casinocage-nj';
    this.cashierContentService.getPageConfig(fileName).then((response: DepositMainLabels) => {
        this.labels = response;
    });
  }

  public selectedDepositBonusOffer($event): void{
    this.bonusCode = $event.selectedbonusOffer.campaign_code;
  }

  onBack = () => {
    this.cashierContentService.onBackHandler(this.navigateBackPage);
  }

}
